export default __webpack_public_path__ + "static/media/11 Office Entrance copy.jpg 2.fad7e5f3.jpg";